import { render, staticRenderFns } from "./self.vue?vue&type=template&id=45992a75&scoped=true&"
import script from "./self.vue?vue&type=script&lang=js&"
export * from "./self.vue?vue&type=script&lang=js&"
import style0 from "./self.vue?vue&type=style&index=0&id=45992a75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45992a75",
  null
  
)

export default component.exports